import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { toArray } from './util';
import { shouldEmbed, embedResources } from './embedResources';
export function parseWebFontRules(clonedNode) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              if (!clonedNode.ownerDocument) {
                reject(new Error('Provided element is not within a Document'));
              }

              resolve(toArray(clonedNode.ownerDocument.styleSheets));
            }).then(getCssRules).then(getWebFontRules));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
export function embedWebFonts(clonedNode, options) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", parseWebFontRules(clonedNode).then(function (rules) {
              return Promise.all(rules.map(function (rule) {
                var baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
                return embedResources(rule.cssText, baseUrl, options);
              }));
            }).then(function (cssStrings) {
              return cssStrings.join('\n');
            }).then(function (cssString) {
              var styleNode = document.createElement('style');
              var sytleContent = document.createTextNode(cssString);
              styleNode.appendChild(sytleContent);

              if (clonedNode.firstChild) {
                clonedNode.insertBefore(styleNode, clonedNode.firstChild);
              } else {
                clonedNode.appendChild(styleNode);
              }

              return clonedNode;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}
export function getCssRules(styleSheets) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var ret, promises;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            ret = [];
            promises = []; // First loop inlines imports

            styleSheets.forEach(function (sheet) {
              if ('cssRules' in sheet) {
                try {
                  toArray(sheet.cssRules).forEach(function (item) {
                    if (item.type === CSSRule.IMPORT_RULE) {
                      promises.push(fetchCSS(item.href, sheet).then(embedFonts).then(function (cssText) {
                        var parsed = parseCSS(cssText);
                        parsed.forEach(function (rule) {
                          sheet.insertRule(rule, sheet.cssRules.length);
                        });
                      }).catch(function (e) {
                        console.log('Error loading remote css', e.toString());
                      }));
                    }
                  });
                } catch (e) {
                  var inline = styleSheets.find(function (a) {
                    return a.href === null;
                  }) || document.styleSheets[0];

                  if (sheet.href != null) {
                    promises.push(fetchCSS(sheet.href, inline).then(embedFonts).then(function (cssText) {
                      var parsed = parseCSS(cssText);
                      parsed.forEach(function (rule) {
                        inline.insertRule(rule, sheet.cssRules.length);
                      });
                    }).catch(function (e) {
                      console.log('Error loading remote stylesheet', e.toString());
                    }));
                  }

                  console.log('Error inlining remote css file', e.toString());
                }
              }
            });
            return _context3.abrupt("return", Promise.all(promises).then(function () {
              // Second loop parses rules
              styleSheets.forEach(function (sheet) {
                if ('cssRules' in sheet) {
                  try {
                    toArray(sheet.cssRules).forEach(function (item) {
                      ret.push(item);
                    });
                  } catch (e) {
                    console.log("Error while reading CSS rules from ".concat(sheet.href), e.toString());
                  }
                }
              });
              return ret;
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

function getWebFontRules(cssRules) {
  return cssRules.filter(function (rule) {
    return rule.type === CSSRule.FONT_FACE_RULE;
  }).filter(function (rule) {
    return shouldEmbed(rule.style.getPropertyValue('src'));
  });
}

function parseCSS(source) {
  if (source === undefined) {
    return [];
  }

  var cssText = source;
  var css = [];
  var cssKeyframeRegex = '((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})';
  var combinedCSSRegex = '((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]' + '*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})'; // to match css & media queries together

  var cssCommentsRegex = new RegExp('(\\/\\*[\\s\\S]*?\\*\\/)', 'gi'); // strip out comments

  cssText = cssText.replace(cssCommentsRegex, '');
  var keyframesRegex = new RegExp(cssKeyframeRegex, 'gi');
  var arr;

  while (true) {
    arr = keyframesRegex.exec(cssText);

    if (arr === null) {
      break;
    }

    css.push(arr[0]);
  }

  cssText = cssText.replace(keyframesRegex, ''); // unified regex

  var unified = new RegExp(combinedCSSRegex, 'gi');

  while (true) {
    arr = unified.exec(cssText);

    if (arr === null) {
      break;
    }

    css.push(arr[0]);
  }

  return css;
}

function fetchCSS(url, sheet) {
  return fetch(url).then(function (res) {
    return {
      url: url,
      cssText: res.text()
    };
  }, function (e) {
    console.log('ERROR FETCHING CSS: ', e.toString());
  });
}

function embedFonts(data) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", data.cssText.then(function (resolved) {
              var cssText = resolved;
              var regexUrlFind = /url\(["']?([^"')]+)["']?\)/g;
              var fontLocations = cssText.match(/url\([^)]+\)/g) || [];
              var fontLoadedPromises = fontLocations.map(function (location) {
                var url = location.replace(regexUrlFind, '$1');

                if (!url.startsWith('https://')) {
                  var source = data.url;
                  url = new URL(url, source).href;
                }

                return new Promise(function (resolve, reject) {
                  fetch(url).then(function (res) {
                    return res.blob();
                  }).then(function (blob) {
                    var reader = new FileReader();
                    reader.addEventListener('load', function (res) {
                      // Side Effect
                      cssText = cssText.replace(location, "url(".concat(reader.result, ")"));
                      resolve([location, reader.result]);
                    });
                    reader.readAsDataURL(blob);
                  }).catch(reject);
                });
              });
              return Promise.all(fontLoadedPromises).then(function () {
                return cssText;
              });
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}